import { render, staticRenderFns } from "./talentGrowth.vue?vue&type=template&id=009bab4e&scoped=true"
import script from "./talentGrowth.vue?vue&type=script&lang=js"
export * from "./talentGrowth.vue?vue&type=script&lang=js"
import style0 from "./talentGrowth.vue?vue&type=style&index=0&id=009bab4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009bab4e",
  null
  
)

export default component.exports